import { Id } from "../../convex/_generated/dataModel";

export const uploadEncryptedPayload = async (
  uploadUrl: string,
  ciphertext: string
): Promise<Id<"_storage">> => {
  const response = await fetch(uploadUrl, {
    method: "POST",
    headers: {
      "Content-Type": "text/plain;charset=utf-8",
    },
    body: ciphertext,
  });

  if (!response.ok) {
    const text = await response.text().catch(() => "");
    throw new Error(
      `Upload failed (${response.status}): ${text.slice(0, 200)}`
    );
  }

  const json = await response.json();
  if (!json.storageId) {
    throw new Error("Upload response missing storageId");
  }
  return json.storageId as Id<"_storage">;
};

export const downloadEncryptedPayload = async (url: string): Promise<string> => {
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`Download failed with status ${response.status}`);
  }
  return await response.text();
};
